import {
  AfterViewInit,
  Component,
  effect,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  signal,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faCircle,
  faCircleCheck,
  faList,
} from '@fortawesome/free-solid-svg-icons';
import { faCircle as startCircle } from '@fortawesome/free-regular-svg-icons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mec-program-steps',
  imports: [CommonModule, FontAwesomeModule, TranslateModule],
  templateUrl: './program-steps.component.html',
  styleUrls: ['./program-steps.component.scss'],
})
export class ProgramStepsComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() public countSteps: number;
  @Input() public stepDescription: string;
  @Input() public currentStepIndex: number;

  @ViewChild('stepContainer')
  public stepContainer: ElementRef;

  public hasOverflow = signal<boolean>(false);
  public viewInitialized = signal<boolean>(false);
  public hasStepsCount = signal<boolean>(false);

  public steps: Array<number> = [];
  public checkIcon = faCircleCheck;
  public listIcon = faList;
  public startIcon = startCircle;
  public endIcon = faCircle;

  private observer: ResizeObserver;

  constructor() {
    effect(() => {
      this._handleStepsContainer();
    });
  }

  public ngOnInit(): void {}

  public ngAfterViewInit(): void {
    this.viewInitialized.set(true);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['countSteps']?.currentValue) {
      this.steps = Array.from({ length: this.countSteps }, (_, index) => index);
      this.hasStepsCount.set(true);
    }
    if (
      changes['currentStepIndex']?.currentValue &&
      !changes['currentStepIndex']?.firstChange
    ) {
      this._scrollToStep(changes['currentStepIndex']?.currentValue);
    }
  }

  private _scrollToStep(newStepIndex: number): void {
    const stepContainer = this.stepContainer.nativeElement;

    const targetStep = stepContainer.querySelector(`#step-${newStepIndex}`);

    if (!targetStep) {
      return;
    }

    targetStep.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }

  private _handleStepsContainer(): void {
    if (this.viewInitialized() && this.hasStepsCount()) {
      this.observer = new ResizeObserver(() => {
        const stepContainer = this.stepContainer.nativeElement;
        this.hasOverflow.set(
          stepContainer.scrollWidth > stepContainer.clientWidth
        );
        this._scrollToStep(this.currentStepIndex);
      });

      this.observer.observe(this.stepContainer.nativeElement);
    }
  }
}
